// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"141":"history formulir","664":"kelas","685":"register","730":"surat tugas","982":"surat keterangan"}[chunkId] + "." + {"141":"2f1187b7","664":"b3802d9a","685":"09558ab8","730":"2869ab0c","982":"2869ab0c"}[chunkId] + ".css";
};